module.exports = __webpack_public_path__ + "static/media/white_no_background.4ce5d5b7.png";